import { render, staticRenderFns } from "./approvalComments.vue?vue&type=template&id=42188140"
import script from "./approvalComments.vue?vue&type=script&lang=js"
export * from "./approvalComments.vue?vue&type=script&lang=js"
import style0 from "./approvalComments.vue?vue&type=style&index=0&id=42188140&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports